import React, { useState } from 'react';

const marketTypes = [
  '', '股票', '商品期货', '加密货币', '黄金', '原油', '外汇'
];
const currencies = ['¥', '$'];

function AccountForm({ accounts, setAccounts }) {
  const [accountName, setAccountName] = useState('');
  const [marketType, setMarketType] = useState('');
  const [initialCapital, setInitialCapital] = useState('');
  const [currency, setCurrency] = useState('¥');

  const handleAddAccount = () => {
    const name = accountName.trim();
    const capital = parseFloat(initialCapital);
    if (!name || marketType === '' || isNaN(capital) || capital <= 0) {
      alert('请填写所有必填字段，且初始本金必须为正数！');
      return;
    }
    if (accounts.some(acc => acc.name === name)) {
      alert('账户名已存在，请使用其他名称！');
      return;
    }
    setAccounts([
      ...accounts,
      { name, market: marketType, capital, currency }
    ]);
    setAccountName('');
    setMarketType('');
    setInitialCapital('');
    setCurrency('¥');
  };

  return (
    <div className="section">
      <h2>添加账户</h2>
      <div>账户名称 <input type="text" value={accountName} onChange={e => setAccountName(e.target.value)} placeholder="请输入账户名称" /></div>
      <div>市场类型
        <select value={marketType} onChange={e => setMarketType(e.target.value)}>
          {marketTypes.map(type => (
            <option key={type} value={type}>{type === '' ? '请选择' : type}</option>
          ))}
        </select>
      </div>
      <div>初始本金 <input type="text" value={initialCapital} onChange={e => setInitialCapital(e.target.value)} placeholder="请输入初始本金" />
        <select value={currency} onChange={e => setCurrency(e.target.value)}>
          {currencies.map(cur => <option key={cur}>{cur}</option>)}
        </select>
      </div>
      <button onClick={handleAddAccount}>添加账户</button>
    </div>
  );
}

export default AccountForm; 